export let TypeGeolocation;

(function (TypeGeolocation) {
  TypeGeolocation["ReqGeolocationCurrentPosition"] = "REQ.GEOLOCATION.CURRENT_POSITION";
})(TypeGeolocation || (TypeGeolocation = {}));